import { NgModule } from '@angular/core';
import { ApiServerUrlPipe } from './api-server-url.pipe';

@NgModule({
  declarations: [ApiServerUrlPipe],
  exports: [ApiServerUrlPipe]
})
export class ApiServerUrlPipeModule {}